// import { Notify } from 'quasar'
import router from '../router'
document.addEventListener('plusready', function () {
  let first = null
  // eslint-disable-next-line no-undef
  plus && plus.key.addEventListener('backbutton', function () {
    // 获取地址栏目中的url
    let urls = router.history.current.path
    if (urls === '/home') { // 判断当前是否无后退页
      if (new Date().getTime() - first < 3000) {
        // 连续按两次返回键且时间小于3s，退出app
        // eslint-disable-next-line no-undef
        plus.runtime.quit()
      } else {
        first = new Date().getTime()// 记录第一次按返回键的时间
        // Notify.create('再按一次退出应用')
        setTimeout(() => {
          // 3s后清除
          first = null
        }, 3000)
      }
    } else {
      history.go(-1) // 返回到上一页
    }
  }, false)
})
